import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { useRealtime } from './RealtimeProvider';
import { bindRealtimeStoreHandlers } from './handlers';
import { isRealtimeWsEnabled } from './config';

/**
 * Binds Redux store handlers once. Does not open sockets — multiplexes on the shared service.
 */
export default function RealtimeStoreBinder() {
  const store = useStore();
  const { subscribe } = useRealtime();

  useEffect(() => {
    if (!isRealtimeWsEnabled()) return undefined;
    return bindRealtimeStoreHandlers(store, subscribe);
  }, [store, subscribe]);

  return null;
}
